import Vue from 'vue';
import Router from 'vue-router';
Vue.use(Router);

export default new Router({
	routes: [

		{
			path: '/',
			component: () => import( /* webpackChunkName: "home" */ '../components/common/Home.vue'),
			redirect: '/homepage',
			meta: {
				title: ''
			},
			children: [{
					path: '/homepage',
					component: () => import('../components/page/Homepage/homepage.vue'),
					meta: {
						title: '主页',
						roles: ['homepage']
					}
				},
				{
					path: '/Interfacelog',
					component: () => import('../components/page/Logmanagement/Interfacelog.vue'),
					meta: {
						title: '接口日志',
						roles: ['Interfacelog']
					}
				},
				{
					path: '/Fileimport',
					component: () => import('../components/page/Controloverinvoices/Fileimport.vue'),
					meta: {
						title: '文件导入',
						roles: ['Fileimport']
					}
				},
				{
					path: '/Fillinandissuepositiveinvoice',
					component: () => import(
						'../components/page/Controloverinvoices/Fillinandissuepositiveinvoice.vue'),
					meta: {
						title: '正数发票填开',
						roles: ['Fillinandissuepositiveinvoice']
					}
				},
				{
					path: '/Filloutnegativeinvoice',
					component: () => import(
						'../components/page/Controloverinvoices/Filloutnegativeinvoice.vue'),
					meta: {
						title: '负数普票填开',
						roles: ['Filloutnegativeinvoice']
					}
				},
				{
					path: '/FilloutZhuannegativeinvoice',
					component: () => import(
						'../components/page/Controloverinvoices/FilloutZhuannegativeinvoice.vue'),
					meta: {
						title: '负数专票填开',
						roles: ['FilloutZhuannegativeinvoice']
					}
				},
				{
					path: '/Fillinthenegativenumber',
					component: () => import(
						'../components/page/Controloverinvoices/Fillinthenegativenumber.vue'),
					meta: {
						title: '负数发票填开',
						roles: ['Fillinthenegativenumber']
					}
				},
				{
					path: '/Invoicevoidmanagement',
					component: () => import(
						'../components/page/Controloverinvoices/Invoicevoidmanagement.vue'),
					meta: {
						title: '发票作废管理',
						roles: ['Invoicevoidmanagement']
					}
				},
				// {
				// 	path: '/Billingmethod',
				// 	component: () => import('../components/page/Controloverinvoices/Billingmethod.vue'),
				// 	meta: {
				// 		title: '开票方式',
				// 		roles: ['Billingmethod']
				// 	}
				// },
				{
					path: '/Billingmethod',
					component: () => import('../components/page/Controloverinvoices/Billingmethod/index.vue'),
					meta: {
						title: '扫码开票',
						roles: ['Billingmethod']
					}
				},
				{
					path: '/Redletterinformationtablemanagement',
					component: () => import(
						'../components/page/Controloverinvoices/Redletterinformationtablemanagement.vue'
					),
					meta: {
						title: '红字信息表管理',
						roles: ['Redletterinformationtablemanagement']
					}
				},
				{
					path: '/Telegraphicdelivery',
					component: () => import(
						'../components/page/Controloverinvoices/Telegraphicdelivery.vue'),
					meta: {
						title: '电票递送',
						roles: ['Telegraphicdelivery']
					}
				},
				{
					path: '/InvoiceQuery',
					component: () => import('../components/page/Controloverinvoices/InvoiceQuery.vue'),
					meta: {
						title: '发票查询',
						roles: ['InvoiceQuery']
					}
				},
				{
					path: '/InvoiceExpressInfo',
					component: () => import(
						'../components/page/Controloverinvoices/InvoiceExpressInfo.vue'),
					meta: {
						title: '快递单上传',
						roles: ['InvoiceExpressInfo']
					}
				},
				{
					path: '/Billingrules',
					component: () => import('../components/page/Controloverinvoices/Billingrules.vue'),
					meta: {
						title: '开票规则',
						roles: ['Billingrules']
					}
				},
				{
					path: '/Querystatistics',
					component: () => import('../components/page/Statisticalreport/Querystatistics.vue'),
					meta: {
						title: '查询统计',
						roles: ['Querystatistics']
					}
				},
				{
					path: '/Invoicestatistics',
					component: () => import(
						'../components/page/Statisticalreport/Invoicestatistics.vue'),
					meta: {
						title: '发票资料统计',
						roles: ['Invoicestatistics']
					}
				},
				{
					path: '/SummaryReport',
					component: () => import('../components/page/Statisticalreport/SummaryReport.vue'),
					meta: {
						title: '汇总报表',
						roles: ['SummaryReport']
					}
				},
				{
					path: '/Taxcontrolupload',
					component: () => import(
						'../components/page/Taxcopyingmanagement/Taxcontrolupload.vue'),
					meta: {
						title: '税控上传',
						roles: ['Taxcontrolupload']
					}
				},
				{
					path: '/Copytaxreturns',
					component: () => import(
						'../components/page/Taxcopyingmanagement/Copytaxreturns.vue'),
					meta: {
						title: '抄报税',
						roles: ['Copytaxreturns']
					}
				},
				{
					path: '/Batchtaxcopying',
					component: () => import(
						'../components/page/Taxcopyingmanagement/Batchtaxcopying.vue'),
					meta: {
						title: '批量抄报税',
						roles: ['Batchtaxcopying']
					}
				},
				{
					path: '/Invoiceapplicationmanagement',
					component: () => import(
						'../components/page/Inventorymanagement/Invoiceapplicationmanagement.vue'),
					meta: {
						title: '发票申领管理',
						roles: ['Invoiceapplicationmanagement']
					}
				},
				{
					path: '/Invoiceonlinedistribution',
					component: () => import(
						'../components/page/Inventorymanagement/Invoiceonlinedistribution.vue'),
					meta: {
						title: '发票网上分发',
						roles: ['Invoiceonlinedistribution']
					}
				},
				{
					path: '/InvoiceInventory',
					component: () => import(
						'../components/page/Inventorymanagement/InvoiceInventory.vue'),
					meta: {
						title: '发票库存查询',
						roles: ['InvoiceInventory']
					}
				},
				{
					path: '/Invoiceinventoryquery',
					component: () => import(
						'../components/page/Inventorymanagement/Invoiceinventoryquery.vue'),
					meta: {
						title: '发票库存预警',
						roles: ['Invoiceinventoryquery']
					},
				},
				{
					path: '/Commoditymasterdata',
					component: () => import(
						'../components/page/Masterdatamanagement/Commoditymasterdata.vue'),
					meta: {
						title: '商品主数据',
						roles: ['Commoditymasterdata']
					}
				},
				{
					path: '/Customermasterdata',
					component: () => import(
						'../components/page/Masterdatamanagement/Customermasterdata.vue'),
					meta: {
						title: '客户主数据',
						roles: ['Customermasterdata']
					}
				},
				{
					path: '/Taxcodedictionary',
					component: () => import(
						'../components/page/Masterdatamanagement/Taxcodedictionary.vue'),
					meta: {
						title: '税务编码字典',
						roles: ['Taxcodedictionary']
					}
				},
				{
					path: '/Operationlogmanagement',
					component: () => import(
						'../components/page/Logmanagement/Operationlogmanagement.vue'),
					meta: {
						title: '操作日志管理',
						roles: ['Operationlogmanagement']
					}
				},
				{
					path: '/Groupandcompany',
					component: () => import('../components/page/Systemsettings/Groupandcompany.vue'),
					meta: {
						title: '集团成员公司',
						roles: ['Groupandcompany']
					}
				},
				{
					path: '/Groupusers',
					component: () => import('../components/page/Systemsettings/Groupusers.vue'),
					meta: {
						title: '集团管理员',
						roles: ['Groupusers']
					}
				},
				{
					path: '/Rolepermissions',
					component: () => import('../components/page/Systemsettings/Rolepermissions.vue'),
					meta: {
						title: '角色权限',
						roles: ['Rolepermissions']
					}
				},
				{
					path: '/Departmentmanagement',
					component: () => import(
						'../components/page/Systemsettings/Departmentmanagement.vue'),
					meta: {
						title: '部门管理',
						roles: ['Departmentmanagement']
					}
				},
				{
					path: '/Member',
					component: () => import('../components/page/Systemsettings/Member.vue'),
					meta: {
						title: '人员管理',
						roles: ['Member']
					}
				},
				{
					path: '/Entitysettings',
					component: () => import('../components/page/Systemsettings/Entitysettings.vue'),
					meta: {
						title: '实体设置',
						roles: ['Entitysettings']
					}
				},
				{
					path: '/Mailtemplateconfiguration',
					component: () => import(
						'../components/page/Systemsettings/Mailtemplateconfiguration.vue'),
					meta: {
						title: '邮件模板配置',
						roles: ['Mailtemplateconfiguration']
					}
				},
				{
					path: '/Exceltemplateconfiguration',
					component: () => import(
						'../components/page/Systemsettings/Exceltemplateconfiguration.vue'),
					meta: {
						title: 'Excel模板配置',
						roles: ['Exceltemplateconfiguration']
					}
				},
				{
					path: '/PaperTicketMailing',
					component: () => import('../components/page/ExpressService/PaperTicketMailing.vue'),
					meta: {
						title: '纸票邮寄',
						roles: ['PaperTicketMailing']
					}
				},
				{
					path: '/PaperTicketPacking',
					component: () => import('../components/page/ExpressService/PaperTicketPacking.vue'),
					meta: {
						title: '纸票打包',
						roles: ['PaperTicketPacking']
					}
				},
				{
					path: '/ExpressSettings',
					component: () => import('../components/page/Systemsettings/ExpressSettings.vue'),
					meta: {
						title: '递送设置',
						roles: ['ExpressSettings']
					}
				},
				{
					path: '/Fileimport_FullyElectronic',
					component: () => import('../components/page/Controloverinvoices/Fileimport.vue'),
					meta: {
						title: '数电文件导入',
						roles: ['Fileimport_FullyElectronic']
					}
				},
				{
					path: '/FillingPositiveInvoice',
					component: () => import(
						'../components/page/FullyElectronicInvoices/FillingPositiveInvoice'),
					meta: {
						title: '数电正数发票填开',
						roles: ['FillingPositiveInvoice']
					}
				},
				{
					path: '/Fillinthenegativenumber_FullyElectronic',
					component: () => import(
						'../components/page/FullyElectronicInvoices/Fillinthenegativenumber/Fillinthenegativenumber.vue'
						),
					meta: {
						title: '数电负数发票填开',
						roles: ['Fillinthenegativenumber_FullyElectronic']
					}
				},
				{
					path: '/Telegraphicdelivery_FullyElectronic',
					component: () => import(
						// '../components/page/Controloverinvoices/FullyElectronic/index.vue'),
						'../components/page/Controloverinvoices/Telegraphicdelivery.vue'),
					meta: {
						title: '数电电票递送',
						roles: ['Telegraphicdelivery_FullyElectronic']
					}
				},
				{
					path: '/InvoiceQuery_FullyElectronic',
					component: () => import('../components/page/Controloverinvoices/InvoiceQuery.vue'),
					meta: {
						title: '数电发票查询',
						roles: ['InvoiceQuery_FullyElectronic']
					}
				},
				{
					path: '/RedInkInvoiceBusiness',
					component: () => import(
						'../components/page/Controloverinvoices/RedInkInvoiceBusiness'),
					meta: {
						title: '红字发票业务',
						roles: ['RedInkInvoiceBusiness']
					}
				},
				{
					path: '/invoiceRepair',
					component: () => import('../components/page/FullyElectronicInvoices/invoiceRepair'),
					meta: {
						title: '发票修复',
						roles: ['invoiceRepair']
					}
				},
				{
					path: '/ManualExportAndImport',
					component: () => import(
						'../components/page/FullyElectronicInvoices/ManualExportAndImport'),
					meta: {
						title: '手工导入导出',
						roles: ['ManualExportAndImport']
					}
				},
				{
					path: '/AdditionalInformation',
					component: () => import(
						'../components/page/Masterdatamanagement/AdditionalInformation'),
					meta: {
						title: '附加信息维护',
						roles: ['AdditionalInformation']
					}
				},
				{
					path: '/CodeManagement',
					component: () => import('../components/page/PreInformationofLeqi/CodeManagement'),
					meta: {
						title: '赋码管理',
						roles: ['CodeManagement']
					}
				},
				{
					path: '/CreditManagement',
					component: () => import('../components/page/PreInformationofLeqi/CreditManagement'),
					meta: {
						title: '授信管理',
						roles: ['CreditManagement']
					}
				},
				{
					path: '/InvoicingQualification',
					component: () => import(
						'../components/page/PreInformationofLeqi/InvoicingQualification'),
					meta: {
						title: '开票资格',
						roles: ['InvoicingQualification']
					}
				},
				{
					path: '/ScheduledTaskSummary',
					component: () => import('../components/page/TaskCenter/ScheduledTaskSummary'),
					meta: {
						title: '定时任务汇总',
						roles: ['ScheduledTaskSummary']
					}
				},
				{
					path: '/InvoiceUpload',
					component: () => import('../components/page/TaskCenter/InvoiceUpload'),
					meta: {
						title: '发票上传',
						roles: ['InvoiceUpload']
					}
				},
				{
					path: '/InvoiceStatusUpdate',
					component: () => import('../components/page/TaskCenter/InvoiceStatusUpdate'),
					meta: {
						title: '发票状态更新',
						roles: ['InvoiceStatusUpdate']
					}
				},
				{
					path: '/DownloadOriginalFile',
					component: () => import('../components/page/TaskCenter/DownloadOriginalFile'),
					meta: {
						title: '下载原文件',
						roles: ['DownloadOriginalFile']
					}
				},
				{
					path: '/LayoutFileGeneration',
					component: () => import('../components/page/TaskCenter/LayoutFileGeneration'),
					meta: {
						title: '版式文件生成',
						roles: ['LayoutFileGeneration']
					}
				},
			]
		},
		{
			path: '/login',
			component: () => import( /* webpackChunkName: "login" */ '../components/page/Login.vue'),
			meta: {
				title: '登录'
			}
		},
		{
			path: '/portalLogin',
			component: () => import( /* webpackChunkName: "login" */ '../components/page/PortalLogin.vue'),
			meta: {
				title: '登录'
			}
		},
		{
			path: '/register',
			component: () => import('../components/page/CommercialRegister/Register.vue'),
			meta: {
				title: '商户注册'
			}
		}, {
			path: '/authenticationRwm',
			component: () => import('../components/page/authenticationRwm/index.vue'),
			meta: {
				title: '二维码身份验证'
			}
		}, {
			path: '/authenticationYzm',
			component: () => import('../components/page/authenticationYzm/index.vue'),
			meta: {
				title: '验证码身份验证'
			}
		},
		{
			path: '*',
			redirect: '/404'
		}
	]
});